<template>
  <div style="display: inline-block; margin: 0; padding: 0;">
    <!--Table -->
    <el-link type="success" @click="showDialog">下载app</el-link>
    <!--<el-button type="success">测量情况</el-button>-->

    <el-dialog title="App二维码" :visible.sync="dialogTableVisible" :modal-append-to-body="false">
      <div class="block">
        <div style="width: 100%;text-align: center;display: inline-block">
          <div style="width: 300px;height: 300px;margin: auto;">
            <canvas id="appQrcodeCanvas" />
          </div>
          <p style="text-align: center">
            使用安卓手机浏览器扫描二维码下载apk文件进行安装
            <!-- <el-link :href="appUrl" type="success" target="_blank">跳转至下载</el-link> -->
            <!-- <a :href="appUrl" type="success" target="_blank">跳转至下载</a> -->
          </p>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="hideDialog">取 消</el-button>
      </div>
    </el-dialog>
  </div>

  
</template>

<script>
  // import MD5 from 'js-md5';
  // import AppInfoParser from 'app-info-parser';
  // import {
  //   promiseDataMeasureCount,
  //   promiseVersionAdd,
  //   promiseVersionDelete, promiseVersionDownload,
  //   promiseVersionList
  // } from "../js/service/apiService";
  import QRCode from 'qrcode';
  // import constant from "../js/constant";
  export default {
    name: "ShowAppQrcode",
    data () {
      return {
        dialogTableVisible: false,
        // appUrl: 'http://rdis.jiancehulian.com/apk/com.rasber.measure/RasberMeasure_1.0.8.apk',
        // appUrl: 'https://rasbertech.oss-cn-beijing.aliyuncs.com/files%2FRasberMeasure_1.0.9.apk',
        appUrl: 'https://rasbertech.oss-cn-beijing.aliyuncs.com/files%2FrasberInc+3.8.apk',
        // appQrcodeCanvas: '',
        // tabIndex: '',
        // versionList: [],
        // tabList: [],
        // fileList: [],
        // appInfo: {},
        // form: {},

        // qrcodeForLatestApkInfo:{},
        // qrcodeForLatestApkVisible: false,

        // measureDate: new Date(),
        // pickerOptions: {
        //
        // },
        // userTotalCount: 0,
        // gridData: []
      }
    },
    methods: {
      async showDialog () {
        let _this = this;
        // 显示弹框
        _this.dialogTableVisible = true;

        // 更新数据
        // _this.refreshData();
        // _this.mounted();
        // TODO 必须是两遍
        await this.showQrcodeForLatestApk();
        await this.showQrcodeForLatestApk();
      },
      hideDialog () {
        let _this = this;
        _this.dialogTableVisible = false;
      },
      // changeDate () {
      //   let _this = this;
      //   _this.refreshData();
      // },
      // handleClick () {

      // },
      // filterTag(value, row) {
      //   return row.tag === value;
      // },
      // filterHandler(value, row, column) {
      //   const property = column['property'];
      //   return row[property] === value;
      // },
      // async uploadVersion () {
      //   let _this = this;

      //   if(this.appInfo && this.appInfo.version){
      //     this.appInfo.code = Number(this.appInfo.code);
      //     this.appInfo.forceUpdate = !!(this.appInfo.forceUpdate);
      //     await promiseVersionAdd(this.appInfo);
      //     this.$message.success('提交成功');
      //     this.refreshData();
      //   }else{
      //     this.$message.error('文件错误')
      //   }
      //   // _this.gridData = [];
      //   // _this.userTotalCount = 0;

      //   // promiseDataMeasureCount({
      //   //   userId: _this.$store.state.auth_userId,
      //   //   timestamp: parseInt(_this.measureDate.getTime()/1000),
      //   // }).then((measureCount)=>{
      //   //   _this.responseData = measureCount;
      //   //   if (_this.responseData !== null) {
      //   //     _this.gridData = _this.responseData.pointCountList;
      //   //     _this.userTotalCount = _this.responseData.totalCount;
      //   //   }
      //   // });

      // },
      // async deleteOne (version) {
      //   await this.$confirm('无法撤回，确认删除？');
      //   await promiseVersionDelete(version.id);
      //   this.refreshData();
      //   this.$message.success('删除成功');
      // },
      // async downloadOne (version) {
      //   await promiseVersionDownload(version.url);
      // },
      // watch: {
      //   // measureDate: (v) => {
      //   //   let _this = this;
      //   //   if (v) {
      //   //     _this.refreshData();
      //   //   }
      //   // }
      // }
      // handleChange (file,fileList) {
      //   // console.log('handleChange',[file,fileList]);
      //   this.fileList = fileList;
      //   // 读取文件并解析
      //   if(this.fileList && this.fileList[0]){
      //     // console.log('this.fileList',this.fileList);
      //     const parser = new AppInfoParser(this.fileList[0].raw);
      //     parser.parse().then(result => {
      //       console.log('app info ----> ', result)

      //       this.appInfo = {
      //         version: result.versionName,
      //         code: result.versionCode,
      //         packageName: result.package,
      //         appName: result.application.label[0],
      //         icon: result.icon,
      //         file: this.fileList[0].raw,
      //       }
      //     }).catch(err => {
      //       console.log('err ----> ', err)
      //     })
      //   }
      // },
      // async refreshData () {
      //   let _this = this;
      //   this.appInfo = {};
      //   this.qrcodeForLatestApkVisible = false;
      //   this.fileList = [];
      //   _this.tabList = [];
      //   // 获取版本列表
      //   _this.versionList = await promiseVersionList();

      //   _this.versionList.forEach((v)=>{
      //     let tab = _this.tabList.find((t)=>{
      //       return t.packageName === v.packageName;
      //     });
      //     if(tab){
      //       if(tab.versionList){
      //         tab.versionList.push(v);
      //       }
      //     }else{
      //       _this.tabList.push({
      //         appName: v.appName,
      //         packageName: v.packageName,
      //         versionList: [v]
      //       })
      //     }
      //   });

      //   console.log('_this.tabList',_this.tabList);
      //   if(_this.tabList.length>0){
      //     _this.tabIndex =_this.tabList[0].packageName;
      //   }
      // },
      async showQrcodeForLatestApk () {
        let _this = this;
        // QRCode
        var canvas = document.getElementById('appQrcodeCanvas');
        console.log('this.appUrl',this.appUrl);
        await QRCode.toCanvas(canvas, this.appUrl, {width: 300}, function (error) {
          if (error) {
            console.error(error)
          }
          console.log('success!');
          _this.$nextTick(function(){
            console.log('nextTick');
          });
        });

        await setTimeout(()=>{},1);
      }
    },
    async mounted () {
      let _this = this;
      // 获取版本列表
      // await this.refresh();
      // await this.showQrcodeForLatestApk();
    }
  }
</script>

<style scoped>

</style>